import { createContext, useContext } from 'react';
import type { DtoolsProjectImportJobOutcome } from 'src/graphql/entities/integrations/dtools/hooks/use-dtools-project-import-job-outcome';

export type SelectedProject = { id: number | string; name: string };

export interface DtoolsImportContextValue {
  /** The projects the preview job ran for; the import runs for exactly these. */
  previewProjects: SelectedProject[];
  previewOutcome: DtoolsProjectImportJobOutcome;
  importOutcome: DtoolsProjectImportJobOutcome;
  isStartingJob: boolean;
  /** An import was started for this preview; only Import more clears it, so it cannot run twice. */
  hasImportStarted: boolean;
  /** Starts the dry run; resolves to whether it started. */
  review: (projects: SelectedProject[]) => Promise<boolean>;
  /** Starts the real import for the previewed projects; resolves to whether it started. */
  importPreviewed: () => Promise<boolean>;
  clearPreview: () => void;
  clearImport: () => void;
  close: () => void;
}

// Steps are pushed as elements whose props are fixed at push time, so they read the jobs from here.
export const DtoolsImportContext = createContext<DtoolsImportContextValue | null>(null);

export const useDtoolsImport = () => {
  const value = useContext(DtoolsImportContext);
  if (!value) {
    throw new Error('useDtoolsImport must be used inside ImportDtoolsProjectModal');
  }
  return value;
};

/** What a step hands back when it closes: Import more returns all the way to the selection. */
export const IMPORT_MORE = 'import-more';
